import React, { useState } from 'react'
import {
	Form,
	Input,
	Radio,
	Select,
	InputNumber,
	Button,
	Divider,
	message,
} from 'antd'
import PlanDetailsForm from 'container/PlanDetailsForm'
import { BillingCycle, CreateSubscriptionBody } from 'types'
import { useAppDispatch } from 'hooks/reduxHooks'
import {
	createSubscriptionAction,
	getSubscriptionsAction,
} from 'slices/subscriptions'

const { Item } = Form

const AddSubscriptionForm: React.FC<{ closeDrawer: () => void }> = ({
	closeDrawer,
}) => {
	const dispatch = useAppDispatch()
	const [form] = Form.useForm()
	const [title, setTitle] = useState<string>('')
	const [billingCycle, setBillingCycle] = useState<BillingCycle>('MONTHLY')
	const [amount, setAmount] = useState<number>(0)
	// const [platform, setPlatform] = useState<string>('')
	const [storageAllowed, setStorageAllowed] = useState<number>(0)
	const [broadcastLimit, setBroadcastLimit] = useState<number>(0)

	const handleBillingCycleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setBillingCycle(e.target.value as BillingCycle)
	}

	const onFinish = (values: any) => {
		const body: CreateSubscriptionBody = {
			title: values.title,
			billingCycle: values.billingCycle,
			amount: values.amount,
			currency: values.currency,
			description: values.description || '',
			plan: {
				title: values.title,
				storageAllowed: parseInt(values.storageAllowed, 10) * (1024 * 1024 * 1024),
				billingCycle: values.billingCycle,
				perMonth: values.billingCycle === 'MONTHLY' ? values.amount : 0,
				perYear: values.billingCycle === 'YEARLY' ? values.amount : 0,
				modules: values.allowedModules || [],
			},
		}
		dispatch(createSubscriptionAction(body))
			.unwrap()
			.then(() => {
				dispatch(getSubscriptionsAction())
				message.success('Subscription created successfully!')
				closeDrawer()
			})
	}
	return (
		<Form
			form={form}
			layout='vertical'
			onFinish={onFinish}
			initialValues={{
				billingCycle: 'MONTHLY',
				currency: 'INR',
				allowedModules: [],
			}}
			onValuesChange={changedValues => {
				if (changedValues.title !== undefined) setTitle(changedValues.title)
				if (changedValues.billingCycle !== undefined)
					setBillingCycle(changedValues.billingCycle)
				if (changedValues.amount !== undefined) setAmount(changedValues.amount)
				// if (changedValues.platform !== undefined)
				// 	setPlatform(changedValues.platform)
				if (changedValues.storageAllowed !== undefined)
					setStorageAllowed(Number(changedValues.storageAllowed))
				if (changedValues.broadcastLimit !== undefined)
					setBroadcastLimit(Number(changedValues.broadcastLimit))
			}}
		>
			<Item
				label='Title'
				name='title'
				rules={[{ required: true, message: 'Please enter a title' }]}
			>
				<Input placeholder='e.g. Velocity' />
			</Item>

			<Item
				label='Billing Cycle'
				name='billingCycle'
				rules={[{ required: true, message: 'Please select billing cycle' }]}
			>
				<Radio.Group onChange={() => handleBillingCycleChange}>
					<Radio value='MONTHLY'>Monthly</Radio>
					<Radio value='YEARLY'>Yearly</Radio>
				</Radio.Group>
			</Item>

			<Item
				label='Currency'
				name='currency'
				rules={[{ required: true, message: 'Please select a currency' }]}
			>
				<Select>
					<Select.Option value='INR'>INR</Select.Option>
					<Select.Option value='USD'>USD</Select.Option>
				</Select>
			</Item>

			<Item
				label='Amount'
				name='amount'
				tooltip='Enter amount in paise (INR) or cents (USD). E.g. 100000 means Rs 1000.'
				rules={[{ required: true, message: 'Please enter the amount' }]}
			>
				<InputNumber style={{ width: '100%' }} min={0} />
			</Item>

			<Item label='Description' name='description'>
				<Input.TextArea rows={3} />
			</Item>

			<Divider />
			<PlanDetailsForm
				form={form}
				plans={[]}
				handlePlanSelect={undefined}
				parentTitle={title}
				parentBillingCycle={billingCycle}
				parentAmount={amount}
				// parentPlatform={platform}
				parentStorageAllowed={storageAllowed}
				parentBroadcastLimit={broadcastLimit}
				disableParentFields
				disableEditableFields={false}
			/>

			<Item>
				<Button type='primary' htmlType='submit'>
					Create Subscription
				</Button>
			</Item>
		</Form>
	)
}

export default AddSubscriptionForm
